/*
  SWOAM – Direkter Warenkorb-Button für Upsell-Produkte
  --------------------------------------------------------------------------
  Zweck: Auf Konfigurator-Produktseiten läuft die App "Live Product Options"
  (CloudLift). Diese erkennt automatisch alle <form action="/cart/add"> auf der
  Seite und fängt deren Absenden ab, um eine vollständige Konfiguration zu
  erzwingen. Dadurch wurde auch unser Upsell-Button (z.B. Trinkverschluss)
  abgefangen und ließ sich nicht unabhängig hinzufügen.

  Lösung: Der Upsell-Button ist KEIN klassisches Produktformular mehr, sondern
  ein einfacher Button (data-direct-atc). Dieses Script fügt das Produkt direkt
  per AJAX (/cart/add.js) hinzu und feuert exakt dieselben Warenkorb-Events wie
  das Theme (siehe theme.js ProductForm), damit der Cart-Drawer wie gewohnt
  aufgeht. Die App hat so nichts mehr zum Abfangen.
*/
(function () {
  if (window.__swoamDirectAtc) return;
  window.__swoamDirectAtc = true;

  document.addEventListener(
    'click',
    async function (event) {
      var button = event.target.closest('[data-direct-atc]');
      if (!button) return;

      // Vor der App laufen und deren Interception unterbinden
      event.preventDefault();
      event.stopImmediatePropagation();

      var variantId = button.getAttribute('data-variant-id');
      if (!variantId || button.hasAttribute('aria-busy')) return;

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-busy', 'true');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      var formData = new FormData();
      formData.set('id', variantId);
      formData.set('quantity', button.getAttribute('data-quantity') || '1');
      formData.set('sections', sectionsToBundle.join(','));
      formData.set('sections_url', root + 'variants/' + variantId);

      var response, responseJson;
      try {
        response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        responseJson = await response.json();
      } catch (e) {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-busy');
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        return;
      }

      button.removeAttribute('disabled');
      button.removeAttribute('aria-busy');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

      var settings = (window.themeVariables && window.themeVariables.settings) || {};

      if (response.ok) {
        if (settings.cartType === 'page' || settings.pageType === 'cart') {
          window.location.href = root + 'cart';
          return;
        }

        var cartContent = await (await fetch(root + 'cart.js')).json();
        cartContent.sections = responseJson.sections;

        button.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: responseJson.hasOwnProperty('items') ? responseJson.items : [responseJson],
              cart: cartContent,
              onSuccessDo: 'force_open_drawer'
            }
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cartContent }
          })
        );
      } else {
        button.dispatchEvent(
          new CustomEvent('cart:error', { bubbles: true, detail: { error: responseJson && responseJson.description } })
        );
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    },
    true // Capture-Phase: vor App-Listenern
  );
})();
